import { LogoNameType, LogoSizeType } from "@/lib/main";

const getLogoHeight = (name: LogoNameType, size: LogoSizeType) => {
  let height = "2.5rem";

  if (
    name === "blue-on-white" ||
    name === "blue-on-white-ar" ||
    name === "white-on-blue" ||
    name === "white-on-blue-ar"
  ) {
    height = (() => {
      switch (size) {
        case "sm":
          return "2.5rem";
        case "md":
          return "3rem";
        default:
          return "2.5rem";
      }
    })();
  }

  if (name === "blue" || name === "white") {
    height = (() => {
      switch (size) {
        case "sm":
          return "1rem";
        case "md":
          return "1.19rem";
        default:
          return "1.75rem";
      }
    })();
  }

  if (name === "blue-ar" || name === "white-ar") {
    height = (() => {
      switch (size) {
        case "sm":
          return "1.4375rem";
        case "md":
          return "3.3125rem";
        default:
          return "1.4375rem";
      }
    })();
  }
  return height;
};

export default getLogoHeight;
